export default "__VITE_ASSET__BbqdKpew__"